module.exports = "<ng-container *cdkPortal>\n    <ng-content></ng-content>\n</ng-container>"